import { DefaultRouteTabs } from '@/components/_common';
import SpedSettingsCompany from '@/components/Fiscal/Sped/SpedSettingsCompany';
import SpedSettingsEdit from '@/components/Fiscal/Sped/SpedSettingsEdit';
import { SpedSettings } from '@/core/domain/sped/sped-settings/sped-settings.types';
import { PageProps } from '@/types/PageProps';
import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

export default function SpedConfigPage({ route }: PageProps) {
  const intl = useIntl();

  const [spedSettings, setSpedSettings] = useState<SpedSettings>();

  return (
    <DefaultRouteTabs
      permissions={route.permissions}
      route={route.parent}
      persistSearchParams={false}
    >
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
        <SpedSettingsCompany
          spedSettings={spedSettings}
          onSettingsSelected={setSpedSettings}
        />

        {!!spedSettings && <SpedSettingsEdit spedSettings={spedSettings} />}
      </div>
    </DefaultRouteTabs>
  );
}
